import { contrastRatio } from './colorContrast';

// The card a pill sits on (redesign.bg.surface) and the ink its label leans
// toward, in each colour mode.
const SURFACE = { light: '#FFFFFF', dark: '#0E1421' };
const INK = { light: '#1A1917', dark: '#FFFFFF' };
const TINT = { light: 0.12, dark: 0.16 };

// The colour a category without one is drawn in (FALLBACK_CATEGORY_COLOR).
export const FALLBACK_TINT_COLOR = '#718096';

const parse = (hex) => [1, 3, 5].map((i) => parseInt(hex.slice(i, i + 2), 16));
const toHex = (rgb) => `#${rgb.map((c) => Math.round(c).toString(16).padStart(2, '0')).join('').toUpperCase()}`;
const mix = (from, to, amount) => from.map((c, i) => c + (to[i] - c) * amount);

/**
 * A category's pill, from the colour the user chose for it: a light tint of
 * that colour as the background, a label in the same hue moved toward the ink
 * only as far as it needs to read at 4.5:1 on the tint, and the colour itself
 * for the dot. The tint is returned opaque, already laid over the card.
 *
 * @param {string} color - the category's colour, `#RRGGBB`
 * @param {'light'|'dark'} mode - Chakra's colour mode
 * @returns {{ bg: string, fg: string, dot: string }}
 */
export function categoryTint(color, mode = 'light') {
  const dot = /^#[0-9a-f]{6}$/i.test(color || '') ? color : FALLBACK_TINT_COLOR;
  const own = parse(dot);
  const bg = toHex(mix(parse(SURFACE[mode]), own, TINT[mode]));
  const ink = parse(INK[mode]);
  let fg = dot;
  for (let step = 1; step <= 10 && contrastRatio(fg, bg) < 4.5; step += 1) {
    fg = toHex(mix(own, ink, step / 10));
  }
  return { bg, fg, dot };
}
